import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { ProjectIdSchema } from '../unique-id.models.ts'
import { SurveyFeedbackSchema, SurveyRatingSchema } from './common.ts'
import { SurveyTypeSchema } from './survey-types.ts'

export const ProjectCompletedBrandReviewsMakerResponsesSchema = z.object({
  makerRating: SurveyRatingSchema,
  finalVideoQualityRating: SurveyRatingSchema,
  feedback: SurveyFeedbackSchema.optional(),
})

export const ProjectCompletedBrandReviewsMakerRatingFieldsSchema =
  ProjectCompletedBrandReviewsMakerResponsesSchema.pick({
    makerRating: true,
    finalVideoQualityRating: true,
  }).keyof()

export type ProjectCompletedBrandReviewsMakerRatingField = ZodInfer<
  typeof ProjectCompletedBrandReviewsMakerRatingFieldsSchema
>

export type ProjectCompletedBrandReviewsMakerResponses = ZodInfer<
  typeof ProjectCompletedBrandReviewsMakerResponsesSchema
>

export const ProjectCompletedBrandReviewsMakerSurveyDetailsSchema = z.object({
  surveyType: SurveyTypeSchema.extract([
    'project-completed-brand-reviews-maker',
  ]),
  projectId: ProjectIdSchema,
  responses: ProjectCompletedBrandReviewsMakerResponsesSchema,
})
